// extracted by mini-css-extract-plugin
module.exports = {"startingLights":"startingLights","inner":"inner","light":"light","active":"active","green":"green"};